module.exports = __webpack_public_path__ + "img/block_1.3c8edd66.webp";